// NetworkDiagramTooltip.js
import React, { useState } from 'react';
import multisiteVpn from '../assets/images/multisite-vpn.png';
import centralizedVpn from '../assets/images/centralized-vpn.png';

const NetworkDiagramTooltip = ({ title, isCentralized = false, siteCount }) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderBenefits = () => {
    if (isCentralized) {
      return (
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
          <h4 className="text-lg font-medium text-blue-900 mb-2">Key Benefits</h4>
          <ul className="space-y-2 text-blue-800">
            <li>• Centralized management simplifies deployment</li>
            <li>• Cost-effective for larger number of sites</li>
            <li>• Improved security and monitoring through central access point</li>
          </ul>
        </div>
      );
    } else {
      return (
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
          <h4 className="text-lg font-medium text-blue-900 mb-2">Key Benefits</h4>
          <ul className="space-y-2 text-blue-800">
            <li>• Direct connections provide optimal performance for each site</li>
            <li>• Independent site management - changes to one site don't affect others</li>
            <li>• Good for small number of sites (2-3 locations)</li>
          </ul>
        </div>
      );
    }
  };

  const renderCostConsiderations = () => {
    if (isCentralized) {
      return (
        <div className="bg-amber-50 border border-amber-100 rounded-lg p-4">
          <h4 className="text-lg font-medium text-amber-900 mb-2">Cost Considerations</h4>
          <ul className="space-y-2 text-amber-800">
            <li>• Centralized VPN reduces the number of VPN endpoints</li>
            <li>• Potential cost savings with more sites</li>
            <li>• Initial setup might be more complex</li>
          </ul>
        </div>
      );
    } else {
      return (
        <div className="bg-amber-50 border border-amber-100 rounded-lg p-4">
          <h4 className="text-lg font-medium text-amber-900 mb-2">Cost Considerations</h4>
          <ul className="space-y-2 text-amber-800">
            <li>• Each site requires its own VPN connection ($35/month per site)</li>
            <li>• Management complexity increases with each new site</li>
            <li>• Consider centralized VPN for 4+ sites to reduce costs</li>
          </ul>
        </div>
      );
    }
  };

  return (
    <div className="inline-block">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-2"
      >
        See how it works
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-xl shadow-xl p-8 m-4 max-w-5xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-start mb-6">
              <div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-2">{title}</h3>
                <p className="text-gray-600">Current configuration with {siteCount} remote sites</p>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                ×
              </button>
            </div>

            <div className="mb-6">
              <img
                src={isCentralized ? centralizedVpn : multisiteVpn}
                alt="Network configuration diagram"
                className="w-full h-auto rounded-lg border border-gray-200"
              />
            </div>

            <div className="space-y-4">
              {renderBenefits()}
              {renderCostConsiderations()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NetworkDiagramTooltip;
